export default __webpack_public_path__ + "static/tecnologia-wallbox-7231721d589102a5b7fbddd03726de9a.jpg";